<template>
  <footer class="footer bg-grey-darkest text-white">
    <div class="container flex flex-wrap">
      <div class="footer-group w-full md:w-1/3 lg:w-1/4 text-sm">
        <div class="title">{{ $t('consultationService') }}</div>
        <ul>
          <li>
            <span class="mb-8 xl:mb-0">{{ $t('consumerHotline') }}：</span>
            <a href="tel:+886-2-6610-0183">+886-2-6610-0183</a>
            <span> ({{ $t('seniorFriendly') }})</span>
          </li>
          <li>
            <span class="mb-8 xl:mb-0">{{ $t('fax') }}：</span>
            <a href="tel:+886-2-6610-0185">+886-2-6610-0185</a>
          </li>
          <li>
            <span class="mb-8 xl:mb-0">{{ $t('customerServiceTime') }}：</span>
            <span>{{ $t('weekday') }} 10:00 ~ 18:30</span>
          </li>
          <!-- <li>
            <span class="mb-8 xl:mb-0">{{ $t('serviceMail') }}：</span>
            <a href="mailto:owljourney@owlting.com">owljourney@owlting.com</a>
          </li> -->
          <li class="social-media mt-40">
            <a aria-label="facebook" href="https://www.facebook.com/OwlJourneyOwlTing/?utm_source=owljourney&utm_medium=footerfacebook&utm_campaign=owljourneyhomepage" target="_blank">
              <i class="owl-social-fb"></i>
            </a>
            <a aria-label="instagram" href="https://www.instagram.com/owljourney_/?utm_source=owljourney&utm_medium=footerinstagram&utm_campaign=owljourneyhomepage" target="_blank">
              <i class="owl-social-ig"></i>
            </a>
            <a aria-label="youtube" href="https://www.youtube.com/channel/UCK5e8EWsC1z-bt_qe34vSkA?utm_source=owljourney&utm_medium=footeryoutube&utm_campaign=owljourneyhomepage" target="_blank">
              <i class="owl-social-youtube"></i>
            </a>
            <a aria-label="line" href="https://line.me/R/ti/p/%40547thikl?utm_source=owljourney&utm_medium=footerline%40&utm_campaign=owljourneyhomepage" target="_blank">
              <i class="owl-social-line"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-group w-full md:w-1/3 lg:w-1/4">
        <div class="title">{{ $t('OwlTing') }}</div>
        <ul>
          <li>
            <a href="https://www.owlting.com/portal/" target="_blank">
              {{ $t('officialWebsite') }}<span v-show="selectedLang !== 'en'">Official Website</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/premium/ " target="_blank">
              {{ $t('owltingPremium') }}<span v-show="selectedLang !== 'en'">OwlTing Premium</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/owlpay/?lang=zh_tw" target="_blank">
              {{ $t('owlpay') }}<span v-show="selectedLang !== 'en'">OwlPay</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/owlnest" target="_blank">
              {{ $t('owlNest') }}<span v-show="selectedLang !== 'en'">OwlNest</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/obs" target="_blank">
              {{ $t('OBS') }}<span v-show="selectedLang !== 'en'">OwlTing Blockchain Services</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/news/" target="_blank">
              {{ $t('owlNews') }}<span v-show="selectedLang !== 'en'">OwlNews</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/market/" target="_blank">
              {{ $t('market') }}<span v-show="selectedLang !== 'en'">OwlTing Market</span>
            </a>
          </li>
          <li>
            <a href="https://www.owlting.com/experiences/" target="_blank">
              {{ $t('owlTingExperience') }}<span v-show="selectedLang !== 'en'">OwlTing Experiences</span>
            </a>
          </li>
          <li>
            <a href="https://owlstay.travel/" target="_blank">
              {{ $t('owlstay') }}<span v-show="selectedLang !== 'en'">OwlStay</span>
            </a>
          </li>
          <li>
            <a href="https://blog.owlting.com/" target="_blank">
              {{ $t('owltingBlog') }}<span v-show="selectedLang !== 'en'">OwlTing Blog</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-group flex flex-wrap flex-col w-full md:w-1/3 lg:w-1/2 lg:flex-row text-sm">
        <div class="mb-32 pr-24 w-full lg:w-1/3">
          <div class="title">{{ $t('websiteTerm') }}</div>
          <ul>
            <li>
              <router-link :to="{name: 'UserTerm'}" target="_blank">{{ $t('termsOfUse') }}</router-link>
            </li>
            <li>
              <a :href="`https://www.owlting.com/portal/about/privacy?lang=${externalLinkLang}`" target="_blank">{{ $t('privacyPolicy') }}</a>
            </li>
            <li>
              <a :href="`https://www.owlting.com/portal/about/cookie-policy?lang=${externalLinkLang}`" target="_blank">{{ $t('cookiePolicy') }}</a>
            </li>
          </ul>
        </div>
        <div class="footer-info w-full lg:w-2/3">
          <div>{{ $t('OwlTingTravel') }}</div>
          <ul class="mb-40">
            <li>
              交觀甲8053-品保北2322
            </li>
            <li>
              {{ $t('representative') + '：' + $t('DarrenWang') }}
            </li>
            <li>
              {{ $t('contact') + '：' + $t('CipherLee') }}
            </li>
            <li>
              <a class="whitespace-pre-line" href="https://maps.app.goo.gl/1Lgiyx5agEysEFMA8" target="_blank">{{ $t('componyAddress') }}</a>
            </li>
            <!-- <li>
              {{ $t('contactPhone') + '：' }}
              <a href="tel:+886-2-6610-0181">+886-2-6610-0181</a>
            </li>
            <li>
              {{ $t('fax') + '：' }} +886-2-6610-0185
            </li> -->
          </ul>
          <div class="title">{{ $t('downloadApplication') }}</div>
          <a href="https://apps.apple.com/tw/app/%E5%A5%A7%E4%B8%81%E4%B8%81%E6%8F%AA%E4%BD%A0%E9%AB%94%E9%A9%97/id1552125085" target="_blank">
            <img width="120" height="36" src="@/assets/images/app-ios.svg" alt="app store" class="mr-8" loading="lazy">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.owlting.app.owljourney" target="_blank">
            <img width="120" height="36" src="@/assets/images/app-google.svg" alt="google play" loading="lazy">
          </a>
        </div>
      </div>
    </div>
    <div class="footer-breakline border-t-1 border-grey"></div>
    <div class="container text-center text-xs p-12">
      <span>{{ $t('copyright') }}</span>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import localeMixin from '@/mixins/locale'

export default {
  name: 'travelFooter',
  mixins: [localeMixin],
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang'
    })
  }
}
</script>

<style lang="sass" scoped>
ul
  @apply pl-0
  list-style-type: none

footer
  .footer-group
    @apply py-16 px-4
    @screen sm
      @apply px-24
    .title
      @apply text-grey text-sm font-medium mb-16
    li
      @apply mb-16 font-medium
      a
        @apply no-underline text-white text-sm
        span
          @apply block mt-8 text-grey-light text-xs
  .footer-info
    li, li a
      @apply text-grey-light font-normal
  .social-media
    i
      @apply text-2xl
</style>
